import React from 'react';
import { Section } from './ui/Section';
import { BatteryIcon, PlugIcon } from 'lucide-react';
export function Objections() {
  return <Section data-id="element-76">
      <div className="bg-blue-50 rounded-2xl p-6 md:p-8 border border-blue-100" data-id="element-77">
        <h2 className="text-xl md:text-2xl font-bold text-[#111827] mb-6 text-center" data-id="element-78">
          ¿Enchufe o Pilas? Vos decidís.
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-79">
          <div className="flex gap-4" data-id="element-80">
            <div className="bg-white p-3 rounded-full h-fit shadow-sm text-blue-600" data-id="element-81">
              <PlugIcon className="w-6 h-6" data-id="element-82" />
            </div>
            <div data-id="element-83">
              <h3 className="font-bold text-[#111827] mb-1" data-id="element-84">
                Modo Fijo (Recomendado)
              </h3>
              <p className="text-sm text-[#4B5563]" data-id="element-85">
                Conectalo con el cable USB (incluido) a cualquier cargador de
                celular o compu. Ideal para dejarlo toda la noche sin gastar.
              </p>
            </div>
          </div>

          <div className="flex gap-4" data-id="element-86">
            <div className="bg-white p-3 rounded-full h-fit shadow-sm text-blue-600" data-id="element-87">
              <BatteryIcon className="w-6 h-6" data-id="element-88" />
            </div>
            <div data-id="element-89">
              <h3 className="font-bold text-[#111827] mb-1" data-id="element-90">Modo Portátil</h3>
              <p className="text-sm text-[#4B5563]" data-id="element-91">
                Usalo con 3 pilas AA (no incluidas) para llevarlo de campamento,
                a lo de los abuelos o si se corta la luz.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}